import { render, staticRenderFns } from "./FareType.vue?vue&type=template&id=fee30c94&"
import script from "./FareType.vue?vue&type=script&lang=js&"
export * from "./FareType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports